import { useEffect, useState } from 'react';
import { STREAMING_VERBS } from './streamingVerbs';

const ROTATION_MS = 1800;

export function useRotatingVerb(active: boolean): string | null {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * STREAMING_VERBS.length),
  );

  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % STREAMING_VERBS.length);
    }, ROTATION_MS);
    return () => clearInterval(id);
  }, [active]);

  if (!active) return null;
  return STREAMING_VERBS[index]!;
}
